export default {
  name: '313C',
  recruitment_game: 'Rekruteringsspel',
  back: 'Terug',
  cancel: 'Annuleren',
  continue: 'Doorgaan',
  skip: 'Overslaan',
  start: 'Start',
  close: 'Sluiten',
  help: 'Help',
  time_left: 'Resterende tijd',
  progress: 'Voortgang',
  privacy_policy: 'Privacybeleid',
  cookies_policy: 'Cookies beleid en Voorwaarden',
  faq: 'Vragen en antwoorden',
  messages: 'Berichten',
  unread: 'ongelezen',
  start_recording: 'Opname starten',
  stop_recording: 'Opname stoppen',
  remove_record: 'Opname verwijderen',
  play_video: 'Afspelen',
  stop_video: 'Stoppen',
  mute_video: 'Dempen',
  unmute_video: 'Dempen uitschakelen',
  replay_video: 'Opnieuw afspelen',
  choose: 'Kies',
  badges: {
    title: 'Insignes',
    badge: 'Insigne',
    my_badges: 'Mijn insigne',
    received: 'Je krijgt een insigne',
    continue: 'Speel verder',
    show_badges: 'Bekijk insignes',
    show_badge: 'Zie de beloning',
  },
  record_test: {
    intro: 'CAMERA- EN MICROFOONINSTELLINGEN TEST',
    content:
      'Voordat u begint met het gereedschap, test uw instellingen. In het veld hieronder zou u het beeld van uw camera moeten zien. Als u dit ziet, betekent het dat uw instellingen waarschijnlijk correct zijn - om zeker te zijn, neem een video op en speel deze af. Als u het beeld van de camera niet ziet, de opname niet kunt afspelen, of andere twijfels heeft, klik dan op de knop "PROBLEEM OPLOSSEN".',
    troubleshoot: 'Probleem Oplossen',
    settings: 'Instellingen',
  },
  questions: {
    progress: 'Vraag',
    accept: 'Bevestig',
    question_has_already_been_answered: 'Deze vraag is al beantwoord.',
  },
  not_found: {
    code: '404',
    title: 'Pagina bestaat niet',
    content:
      'De pagina die je zoekt is niet gevonden. Het kan zijn verwijderd, de naam is veranderd of het bestaat gewoon niet.',
  },
  phone: 'Telefoonnummer',
  select_language: 'Kies taal / Choose language',
  title:
    'Deze website gebruikt cookies om u een geweldige gebruikerservaring te bieden. Door deze site te gebruiken, gaat u akkoord met het gebruik van',
  link: 'cookies door ons.',
  button: 'Sluiten',
  warning: {
    title: 'Er is een fout opgetreden',
    content: 'Probeer het opnieuw en als de fout blijft optreden, laat het ons weten per',
    content_without_email:
      'Probeer het opnieuw en als de fout blijft aanhouden, neem dan contact op met de technische ondersteuning.',
    confirm: 'Sluiten',
  },
  end_time: {
    title: 'Fout melden',
    content:
      'Als er tijdens uw spel een fout optreedt, neem dan contact op via het volgende e-mailadres:',
  },
  record_video_error: {
    not_allowed_title: 'Geen machtigingen',
    not_allowed_desc:
      'Geen toegang tot de camera en/of microfoon. Controleer de browserinstellingen en verleen machtigingen.',
    not_found_title: 'Geen aangesloten apparaat',
    not_found_desc:
      'Geen camera of microfoon gedetecteerd. Controleer of de apparaten correct zijn aangesloten.',
    not_readable_title: 'Apparaat in gebruik door een andere toepassing',
    not_readable_desc:
      'De camera en/of microfoon wordt door een andere toepassing gebruikt. Sluit deze toepassing en probeer het opnieuw (het kan nodig zijn de pagina te vernieuwen).',
    unknown_title: 'Onbekende fout',
    unknown_desc:
      'Er is een onbekende fout opgetreden (bijv. problemen met drivers of een beschadigd apparaat). Raadpleeg de sectie Probleemoplossing en probeer het opnieuw.',
  },
  unsupported_os: {
    content: `
      <span class="swal2-title">Niet-ondersteund apparaat</span>
      <hr>
      <div class="swal2-wrapper">
        <p>Om verder te gaan, gelieve een <strong>ander apparaat en/of browser te gebruiken.</strong></p>
        <p>De wervingshulpmiddel die u van plan bent te gebruiken bevat minstens één taak waarbij u uw antwoord in videoformaat moet opnemen. Helaas staan niet alle apparaten en/of browsers dit correct toe.</p>
        <p><strong>Als u dit scherm ziet, betekent dit dat uw apparaat en/of browser niet de correcte opname en verzending van een videobestand kunnen garanderen.</strong> Hieronder vindt u de aanbevolen instellingen.</p>
        <br>
        <p><strong>Desktopapparaten:</strong></p>
        <p>Windows: Google Chrome, Firefox, Opera, MS Edge</p>
        <p>macOS: Google Chrome, Firefox, Opera, Safari, MS Edge</p>
        <p>Ubuntu: Google Chrome, Firefox, Opera</p>
        <br>
        <p><strong>Mobiele apparaten:</strong></p>
        <p>Andriod: Google Chrome, Firefox, Opera</p>
        <p>iOS (iPhone/iPad): Safari</p>
      </div>
      <hr>
    `,
  },
  skip_stage_without_record: {
    title: 'Weet u zeker dat u de taak wilt overslaan?',
    content:
      '<p>Het opnemen van een video-antwoord voor deze taak is niet verplicht, maar wordt aanbevolen - het zal ons helpen u beter te leren kennen. Weet u zeker dat u het opnemen van een video-antwoord wilt overslaan?</p>',
  },
  skip_stage_with_record: {
    title: 'Weet u zeker dat u de taak wilt overslaan?',
    content:
      '<p>U hebt de bedoeling om het opslaan van de opgenomen video-antwoord over te slaan - het zal niet toegankelijk zijn voor de persoon die het wervingsproces uitvoert. Het uploaden van een video-antwoord voor deze taak is niet verplicht, maar wordt aanbevolen - het zal ons helpen u beter te leren kennen. Bent u zeker dat u het opslaan van het opgenomen video-antwoord wilt overslaan?</p>',
  },
  instruction_camera: {
    content: `
      <span class="swal2-title">Probleemoplossing Camera en Microfoon</span>
      <hr>
      <div class="swal2-wrapper">
      <p>Als de opname of het afspelen niet correct is, kunt u enkele stappen volgen die het probleem zouden moeten oplossen. De meest voorkomende oorzaken van problemen zijn te wijten aan de instellingen van het apparaat, inclusief andere programma's of applicaties die tegelijkertijd de camera en/of microfoon gebruiken.</p>
      <p>Mogelijke oplossingen:</p>
      <ol>
        <li>Zorg ervoor dat de browser toestemming heeft om de microfoon en camera te gebruiken. Zo niet, wijzig de instellingen en ververs de pagina.</li>
        <li>Zorg ervoor dat geen enkele andere applicatie of programma momenteel de camera/microfoon gebruikt (bijv. MS Teams, Photo Booth, of FaceTime) - sluit de applicaties die het gebruik van de camera door de browser blokkeren en ververs de pagina.</li>
        <li>Controleer of uw browser is bijgewerkt naar de nieuwste versie - zo niet, voer een update uit en herhaal de test.</li>
        <li>Als de bovenstaande stappen niet hebben geholpen, probeer dan een andere browser of apparaat te gebruiken.</li>
      </ol>
      <p>Als het probleem aanhoudt, laat het ons weten op { supportEmail } door informatie over het apparaat en de browser waarop het probleem voorkomt te sturen.</p>
      </div>
      <hr>
    `,
  },
  recaptcha: 'Markeer ReCaptcha',
  phone_incorrect: 'Voer een geldig telefoonnummer in',
  missing_answer_error:
    'Om verder te gaan, selecteer twee antwoorden: één met de duim omhoog en één met de duim omlaag.',
  rotate_phone_video: 'Draai je telefoon horizontaal om de video in een groter formaat te bekijken',
  rotate_phone_image:
    'Draai je telefoon horizontaal om de afbeelding in een groter formaat te bekijken',
  attachments: 'Bijlagen',
};
